<template>
  <PersonalAreaTemplate
    :editing="editing"
    :max-width="modal ? null : 650"
    :fileAdd="checkData.image.length <= 12"
    :files="checkData.image"
    :delete-files="checkData.deleteFiles"
    :on-save="onSave"
  >
    <v-form ref="form" lazy-validation>
      <BaseInput
        type="date-picker"
        :label="localStorage.translations.pages['setting-personal_area'].labels['srok-deystiviya']"
        v-model="checkData.dateEnd"
        placeholder="–"
        :min="new Date().toISOString().slice(0, 10)"
        clearable
        :rules="checkData.image.length ? ['required'] : null"
        :view="!editing"
        :view-value="checkData.dateEnd ? $formatDate(checkData.dateEnd) : '-'"
      />
    </v-form>
  </PersonalAreaTemplate>
</template>

<script>
import { mapActions } from 'vuex'
import PersonalAreaTemplate from 'components/personalArea/personalAreaTemplate'

export default {
  name: 'Valttikortti',
  props: {
    editing: Boolean,
    valttikortti: Object,
    userId: Number,
    onSave: Function,
    modal: Boolean,
  },
  components: { PersonalAreaTemplate },
  data: () => ({
    valttikorttiData: null,
    checkData: {
      image: [],
      dateEnd: null,
      deleteFiles: [],
    },
  }),
  watch: {
    valttikortti() {
      if (this.valttikortti) {
        this.valttikorttiData = JSON.parse(this.valttikortti.data)
      }
    },
    valttikorttiData() {
      if (this.valttikorttiData) {
        this.checkData.image = this.valttikorttiData.image ? [this.valttikorttiData.image] : []
        this.checkData.dateEnd = this.valttikorttiData.date_end
      }
      this.onNavigationGuardianCheck({
        data: { valttikortti: this.checkData },
        overwrite: true,
      })
    },
    checkData: {
      deep: true,
      handler() {
        if (this.editing) {
          this.onNavigationGuardianCheck({
            data: { valttikortti: this.checkData },
            overwrite: false,
          })
        }
      },
    },
    // image() {
    //     for (let i in this.image) {
    //         if (this.image[i] === null || '' || undefined) {
    //             this.image.splice(i, 1)
    //         }
    //     }
    // },
  },
  mounted() {
    if (this.valttikortti && !this.valttikorttiData) {
      this.valttikorttiData = JSON.parse(this.valttikortti.data)
    }
  },
  computed: {
    personalAreaUserEdit() {
      return this.$route.name === 'PersonalAreaEdit'
    },
  },
  methods: {
    ...mapActions('navigationGuardian', ['onNavigationGuardianCheck']),
    async deleteImageBD() {
      if (this.checkData.deleteFiles.length) {
        for (let i in this.checkData.deleteFiles) {
          this.$store.dispatch('deleteFile', {
            url: this.checkData.deleteFiles[i],
          })
        }
      }
    },
    submitFile(file, i) {
      return new Promise((resolve, reject) => {
        let formData = new FormData()
        formData.append('file', file)
        this.$store
          .dispatch('uploadFile', {
            data: formData,
            use_case: file.type === 'application/pdf' ? null : 'cover',
          })
          .then((response) => {
            this.checkData.image[i] = response.data.url
            return resolve(response)
          })
          .catch((err) => {
            this.checkData.image.splice(i, 1)
            return reject(err)
          })
      })
    },
    async saveChange() {
      return new Promise(async (resolve, reject) => {
        if (this.$checkNavigationGuardianChange('valttikortti')) {
          await Promise.all(
            this.checkData.image.map(async (file, index) => {
              if (typeof file !== 'string') {
                await this.submitFile(file, index)
              }
            }),
          )
          await this.deleteImageBD()
          let data = {
            type: 'valttikortti',
            data: JSON.stringify({
              image: this.checkData.image[this.checkData.image.length - 1],
              date_end: this.checkData.dateEnd,
            }),
          }
          if (!this.valttikortti || this.valttikortti.data === null) {
            if (this.$route.name === 'PersonalAreaEmployeeEdit') {
              data.user_id = this.userId
            }
          } else {
            data.id = this.valttikortti.id
          }
          resolve(data)
        } else resolve(true)
      })
    },
  },
}
</script>
